import useLocalStorage from '../../../hooks/useLocalStorage';

const JUST_LAUNCHED_LOCAL_STORAGE_KEY = 'JustLaunchedLink';
const ONE_DAY = 24 * 60 * 60 * 1000;

const getLatestLaunchedUpdate = (lastUpdated: number | null, now: number) =>
    lastUpdated !== null && lastUpdated <= now ? lastUpdated : 0;

export const hasUpdateJustLaunched = (lastUpdated: number | null, now: number, lastVisited: number) =>
    lastUpdated !== null && lastUpdated > lastVisited && lastUpdated <= now;

export const shouldShowJustLaunched = (
    lastUpdated: number | null,
    now: number,
    lastVisited: number,
    lastDismissedAt = 0
) => {
    const latestUpdate = getLatestLaunchedUpdate(lastUpdated, now);
    const isDismissed = latestUpdate > 0 && lastDismissedAt >= latestUpdate;

    if (isDismissed) {
        return false;
    }

    return now - lastVisited < ONE_DAY || hasUpdateJustLaunched(lastUpdated, now, lastVisited);
};

export type JustLaunchedHook = ReturnType<typeof useJustLaunched>;
export const useJustLaunched = (lastUpdated: Date) => {
    const [state, setState] = useLocalStorage(JUST_LAUNCHED_LOCAL_STORAGE_KEY, { lastVisit: 0, lastDismissedAt: 0 });
    const lastDismissedAt = state.lastDismissedAt ?? 0;

    return {
        shouldShow: shouldShowJustLaunched(lastUpdated.getTime(), Date.now(), state.lastVisit, lastDismissedAt),
        hasUpdate: hasUpdateJustLaunched(lastUpdated.getTime(), Date.now(), state.lastVisit),
        markAsVisited: () => setState({ ...state, lastVisit: Date.now() }),
        dismiss: () => setState({ ...state, lastDismissedAt: Date.now() }),
    };
};
